import { Seo } from "@/seo/Seo";
import { PageHero } from "@/layouts/PageHero";
import { Section } from "@/components/common/Section";
import { Container } from "@/components/common/Container";
import { Reveal } from "@/components/common/Reveal";
import type { LegalSection } from "@/types/content";

interface LegalPageProps {
  title: string;
  seoTitle: string;
  seoDescription: string;
  path: string;
  updated: string;
  intro: string;
  sections: LegalSection[];
}

/** Reusable long-form legal document layout (Privacy, Terms). */
export function LegalPage({
  title,
  seoTitle,
  seoDescription,
  path,
  updated,
  intro,
  sections,
}: LegalPageProps) {
  return (
    <>
      <Seo title={seoTitle} description={seoDescription} path={path} noindex />
      <PageHero eyebrow="Legal" titleLines={[title]} description={intro} />

      <Section spacing="compact" className="pt-0">
        <Container>
          <div className="mx-auto max-w-3xl">
            <p className="text-sm text-muted-foreground">Last updated: {updated}</p>
            <div className="mt-10 space-y-10">
              {sections.map((section) => (
                <Reveal key={section.heading}>
                  <div>
                    <h2 className="font-heading text-lg font-bold text-foreground sm:text-xl">
                      {section.heading}
                    </h2>
                    <div className="mt-3 space-y-3">
                      {section.paragraphs.map((p, i) => (
                        <p key={i} className="text-[15px] leading-relaxed text-muted-foreground">
                          {p}
                        </p>
                      ))}
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </Container>
      </Section>
    </>
  );
}
